import { FormikErrors, useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { ClinicalNotesFormType } from '../types';

const convertObjectToDotNotation = (obj: FormikErrors<ClinicalNotesFormType>) => {
  const result: string[] = [];

  const traverse = (obj: FormikErrors<ClinicalNotesFormType>, parentKey = '') => {
    for (const key in obj) {
      if (obj[key]) {
        const currentKey = parentKey ? `${parentKey}${Array.isArray(obj) ? `[${key}]` : `.${key}`}` : key;

        if (typeof obj[key] === 'object' && obj[key] !== null) {
          traverse(obj[key], currentKey);
        } else {
          result.push(currentKey);
        }
      }
    }
  };

  traverse(obj);

  return result;
};


export const ScrollToFieldError: React.VFC<{ enabled?: boolean }> = ({ enabled = true }) => {
  // if user completes form and then removes a field, causing it to be invalid, the useEffect would scroll to that error
  // to avoid this, we keep track of submit count here so that scroll behavior only happens when user tries submitting
  const [ lastSubmitCount, setLastSubmitCount ] = useState(0);
  const { submitCount, isValid, errors } = useFormikContext<ClinicalNotesFormType>();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (isValid || lastSubmitCount === submitCount || !Object.keys(errors).length) {
      return;
    }

    const errorNames = convertObjectToDotNotation(errors);

    const errorElements = errorNames.map((errorName) => (
      document.querySelector(`[name='${errorName}']`)
      ?? document.querySelector(`[data-field-name='${errorName}']`)
    )).filter(e => Boolean(e));

    const firstErrorElement = errorElements.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top)[0];

    if (!firstErrorElement) {
      return;
    }

    firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setLastSubmitCount(submitCount);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ submitCount, lastSubmitCount, isValid, enabled ]);

  return null;
};
